import React from 'react';
import Navbar from '../../components/Navbar';
import VideoSection from '../VideoSection';
import Cards from '../Cards';
import VideoSection2 from '../VideoSection2';
import Cards2 from '../Cards2';
import NavbarAccount from '../../components/NavbarAccount';
import { UserAuth } from '../../context/AuthContext';

const Home = () => {
  const { currentUser } = UserAuth();
  console.log(currentUser)

  if (currentUser) {
    return (
      <div>
        <NavbarAccount />
        <VideoSection />
        <Cards />
        <VideoSection2 />
        <Cards2 />
      </div>
    );
    
  } else {
    return (
      <div>
        <Navbar />
        <VideoSection />
        <Cards />
        <VideoSection2 />
        <Cards2 />
      </div>
    );
  }
}

export default Home;